import { render, staticRenderFns } from "./imageTextBlock.vue?vue&type=template&id=c1f4b1ae&"
import script from "./imageTextBlock.vue?vue&type=script&lang=js&"
export * from "./imageTextBlock.vue?vue&type=script&lang=js&"
import style0 from "./imageTextBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports